import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Form } from '@ant-design/compatible';
import { Drawer, Descriptions, Divider, Button, Row, Col, Avatar, Typography, Tooltip, Table } from 'antd'
import { EditOutlined, CheckCircleTwoTone, CloseCircleTwoTone } from '@ant-design/icons';
import { checkPermission } from '../../utils/permission';
import moment from 'moment';
import { getFirstLetterOfWords } from '../../utils/helpers';
import ReactHtmlParser from 'react-html-parser';
import { isMobile } from 'react-device-detect';
import VoucherForm from './VoucherForm';
import CustomerDetail from '../customers/CustomerDrawerDetail';
import { getSpecificCustomer } from '../../redux/actions/customerActions';
const { Paragraph } = Typography;
class VoucherDetail extends Component {
    constructor() {
        super();
        this.state = {
            isOpenEditForm: false,
            isOpenCustomerDetail: false,
            currenCustomertData: null,
            loadingDetail: false
        };
    }

    handleCancel() {
        this.props.onCancel();
    }

    toggleOpenEditForm(isOpenEditForm) {
        this.setState({ isOpenEditForm: isOpenEditForm });
    }

    toggleOpenCustomerDetail(isOpenCustomerDetail, data = null) {
        this.setState({ isOpenCustomerDetail: isOpenCustomerDetail, currenCustomertData: data });
    }

    onCustomerDetail(id) {
        this.setState({ currentCustomer_id: id, loadingDetail: true })
        this.props.getSpecificCustomer(id).then(res => {
            this.setState({ loadingDetail: false })
            this.toggleOpenCustomerDetail(true, res);
        })
    }

    render() {
        var { isOpenEditForm, isOpenCustomerDetail, currenCustomertData, currentCustomer_id, loadingDetail } = this.state;
        var { visible, currentItem } = this.props;

        const columns = [
            {
                title: 'Họ và tên',
                dataIndex: 'full_name',
                key: 'full_name',
                width: '50%',
                render: (text, record) => {
                    var class_name = ''
                    var tooltip_title = 'Xem hồ sơ khách hàng';
                    if (record.tasks == 'delete') {
                        class_name = 'is_delete_item';
                        tooltip_title = "Đã xóa"
                    }
                    if (record.full_name) {
                        if (checkPermission('customer', 'detail')) {
                            return (
                                <Tooltip title={tooltip_title} placement="right">
                                    <div className='color-primary item-action-btn' onClick={() => this.onCustomerDetail(record.customer_id)}>
                                        <Avatar
                                            style={{
                                                backgroundColor: '#31cdf5',
                                                verticalAlign: 'middle'
                                            }}
                                            size="small">{record.full_name ? getFirstLetterOfWords(record.full_name) : ''}</Avatar>
                                        &nbsp;<span className={class_name}>{record.full_name}</span>
                                    </div>
                                </Tooltip>
                            )
                        } else {
                            return (
                                <>
                                    <Avatar
                                        style={{
                                            backgroundColor: '#31cdf5',
                                            verticalAlign: 'middle'
                                        }}
                                        size="small">{record.full_name ? getFirstLetterOfWords(record.full_name) : ''}</Avatar>
                                    &nbsp;<span className={class_name}>{record.full_name}</span>
                                </>
                            )
                        }
                    } else {
                        return <>N/A</>
                    }
                }
            },
            {
                title: 'Mã KH',
                dataIndex: 'customer_code',
                key: 'customer_code',
                width: '25%',
                sorter: true,
                render: (text, record) => {
                    if (text) {
                        return (
                            <Paragraph style={{ margin: 0 }} copyable={
                                {
                                    text: record ? record.customer_code : null,
                                    tooltips: false
                                }
                            }>
                                {text}
                            </Paragraph>
                        )
                    }
                }
            },
            {
                title: 'Ngày khách sử dụng',
                dataIndex: 'used_date',
                key: 'used_date',
                width: '25%',
                render: (text, record) => {
                    return (
                        <div>{moment(text).format('DD/MM/YYYY')}</div>
                    )
                }
            }
        ];

        return (
            <>
                <Drawer
                    visible={visible}
                    title={currentItem && currentItem.name ? currentItem.name : "Chi tiết voucher"}
                    onClose={() => this.handleCancel()}
                    maskClosable={false}
                    width={isMobile ? '100%' : '55%'}
                    extra={
                        checkPermission('voucher', 'update') ? (
                            <Button type="primary" onClick={() => this.toggleOpenEditForm(true)} icon={<EditOutlined />}>Sửa</Button>
                        ) : null
                    }
                >
                    {visible ? (
                        <div>
                            <Row gutter={16}>
                                <Col xs={24} md={24}>
                                    <Descriptions size="small">
                                        <Descriptions.Item label="Tên voucher">
                                            {currentItem ? currentItem.name : null}
                                        </Descriptions.Item>
                                    </Descriptions>
                                    <Divider className="no-margin" />
                                </Col>
                                <Col xs={24} md={24}>
                                    <Descriptions size="small">
                                        <Descriptions.Item label="Mã voucher">
                                            {currentItem ? currentItem.code : null}
                                        </Descriptions.Item>
                                    </Descriptions>
                                    <Divider className="no-margin" />
                                </Col>
                                <Col xs={24} md={24}>
                                    <Descriptions size="small">
                                        <Descriptions.Item label="Discount">
                                            {currentItem ? currentItem.discount : null}
                                        </Descriptions.Item>
                                    </Descriptions>
                                    <Divider className="no-margin" />
                                </Col>
                                <Col xs={24} md={24}>
                                    <Descriptions size="small">
                                        <Descriptions.Item label="Ngày bắt đầu">
                                            {currentItem ? moment(currentItem.start_date).format('DD/MM/YYYY') : null}
                                        </Descriptions.Item>
                                    </Descriptions>
                                    <Divider className="no-margin" />
                                </Col>
                                <Col xs={24} md={24}>
                                    <Descriptions size="small">
                                        <Descriptions.Item label="Ngày hết hạn">
                                            {currentItem ? moment(currentItem.end_date).format('DD/MM/YYYY') : null}
                                        </Descriptions.Item>
                                    </Descriptions>
                                    <Divider className="no-margin" />
                                </Col>
                                <Col xs={24} md={24}>
                                    <Descriptions size="small">
                                        <Descriptions.Item label="Trạng thái">
                                            {
                                                currentItem && currentItem.status == 1 ? <>`<CheckCircleTwoTone twoToneColor="#52c41a" /> Active</> : null
                                            }
                                            {
                                                currentItem && currentItem.status == 0 ? <><CloseCircleTwoTone twoToneColor="#e74c3c" /> Inactive</> : null
                                            }
                                        </Descriptions.Item>
                                    </Descriptions>
                                    <Divider className="no-margin" />
                                </Col>
                            </Row>
                            <Row gutter={16}>
                                <Col xs={24} md={24}>
                                    <Descriptions size="small">
                                        <Descriptions.Item label="Chi tiết">
                                            {currentItem ? ReactHtmlParser(currentItem.detail) : null}
                                        </Descriptions.Item>
                                    </Descriptions>
                                    <Divider className="no-margin" />
                                </Col>
                            </Row>
                            <Row gutter={16}>
                                <Col xs={24} md={24}>
                                    <Descriptions size="small">
                                        <Descriptions.Item label="Ghi chú">
                                            {currentItem ? ReactHtmlParser(currentItem.note) : null}
                                        </Descriptions.Item>
                                    </Descriptions>
                                </Col>
                            </Row>
                            <Divider />
                            <Row gutter={16}>
                                <Col xs={24} md={24}>
                                    <Descriptions size="small">
                                        <Descriptions.Item label="Ngày tạo">
                                            {currentItem ? moment(currentItem.created_at).format('DD/MM/YYYY HH:mm') : null}
                                        </Descriptions.Item>
                                    </Descriptions>
                                    <Divider className="no-margin" />
                                </Col>
                                <Col xs={24} md={24}>
                                    <Descriptions size="small">
                                        <Descriptions.Item label="Người tạo">
                                            {currentItem ? currentItem.created_user : null}
                                        </Descriptions.Item>
                                    </Descriptions>
                                </Col>
                            </Row>
                            <Divider orientation="left" orientationMargin="0" className='mt-3'>
                                Khách hàng sử dụng ({currentItem?.customers.length})
                            </Divider>
                            <Table
                                rowKey="id"
                                size="small"
                                tableLayout='auto'
                                dataSource={currentItem?.customers || []}
                                columns={columns}
                                pagination={false}
                                scroll={{
                                    x: 'max-content'
                                }}
                            />
                        </div>
                    ) : null}

                </Drawer>
                <VoucherForm
                    visible={isOpenEditForm}
                    currentItem={currentItem}
                    reloadData={() => this.props.reloadData()}
                    onCancel={() => this.toggleOpenEditForm(false)}
                />
                <CustomerDetail
                    visible={isOpenCustomerDetail}
                    currentItem={currenCustomertData}
                    reloadData={() => this.onCustomerDetail(currentCustomer_id)}
                    onCancel={() => this.toggleOpenCustomerDetail(false)}
                    loadingDetail={loadingDetail}
                />
            </>
        )
    }
}
function mapStateToProps(state) {
    return {
        authUser: state.auth.authUser
    }
}

function mapDispatchToProps(dispatch) {
    return {
        getSpecificCustomer: (id) => dispatch(getSpecificCustomer(id))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Form.create({ name: 'VoucherDetail' })(VoucherDetail));
